<template>
  <div id="tryout-form">
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{ path: '/' }">Home</router-link>
      </li>
      <li class="active">Setting Affiliate</li>
    </ol>
    <h1 class="page-header">Setting Affiliate</h1>
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Setting</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-md-12">
                <h4>Configuration Affiliate</h4>
                <div class="form-horizontal">
                  <div class="form-group">
                    <label class="col-md-2 control-label" style="">1 Rupiah (Sama dengan)</label>
                    <div class="col-md-3 col-xs-12">
                      <div class="input-group">
                        <input type="number" v-model="formConfig.coin_to_rupiah" class="form-control"
                          placeholder="Bilangan dalam koin">
                        <span class="input-group-addon" id="basic-addon2">Koin</span>
                      </div>

                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-md-2 control-label" style="">Minimum cash withdrawal</label>
                    <div class="col-md-5 col-xs-12">
                      <div style="display: flex; flex-flow: ">
                        <div class="input-group">
                          <input type="number" class="form-control" v-model="formConfig.minimum_coin_withdraw"
                            placeholder="Bilangan dalam Rupiah" />
                          <span class="input-group-addon" id="basic-addon2">Rupiah</span>
                        </div>

                        <span style="
                                    width: 250px;
                                    display: flex;
                                    align-items: center;
                                    padding-left: 20px;
                                  ">= &nbsp;<b>{{ formConfig.minimum_coin_withdraw * formConfig.coin_to_rupiah | currency
                                  }}</b>&nbsp; Koin</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-md-2 control-label" style="">Biaya admin</label>
                    <div class="col-md-5 col-xs-12">
                      <div style="display: flex; flex-flow: ">
                        <div class="input-group">
                          <input type="number" v-model="formConfig.admin_coin_fee" class="form-control"
                            placeholder="Bilangan dalam Rupiah" />
                          <span class="input-group-addon" id="basic-addon2">Rupiah</span>
                        </div>

                        <span style="
                                    width: 250px;
                                    display: flex;
                                    align-items: center;
                                    padding-left: 20px;
                                  ">= &nbsp;<b>{{ formConfig.admin_coin_fee * formConfig.coin_to_rupiah |
                                    currency }}</b>&nbsp; Koin</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-md-2 control-label" style="">Kelipatan</label>
                    <div class="col-md-5 col-xs-12">
                      <div style="display: flex; flex-flow: ">

                        <div class="input-group">
                          <input type="number" v-model="formConfig.multiple_coin_withdraw" class="form-control"
                            placeholder="Bilangan dalam Rupiah" />
                          <span class="input-group-addon" id="basic-addon2">Rupiah</span>
                        </div>
                        <span style="
                                    width: 250px;
                                    display: flex;
                                    align-items: center;
                                    padding-left: 20px;
                                  ">= &nbsp;<b>{{ formConfig.multiple_coin_withdraw *
                                    formConfig.coin_to_rupiah | currency
                                  }}</b>&nbsp; Koin</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-md-2 control-label" style="">Captions Share Link</label>
                    <div class="col-md-5 col-xs-12">
                      <textarea v-model="formConfig.affiliate_message" class="form-control"
                        placeholder="Caption Share Product"></textarea>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-md-12" style="display: flex; align-items: center; justify-content: center">
                      <div style="background: white; display: flex; flex-flow: column">
                        <span style="color: white; font-weight: bold; margin: 10px">Tekan untuk menyimpan semua perubahan
                          data!</span>
                        <button @click="saveData()" class="btn btn-success btn-large">
                          Simpan
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <h4>Persentase Komisi :</h4>
                <div class="row" style="padding-left:10px;">
                  <div class="col-md-2" style="padding-bottom: 15px; padding-left: 0px">
                    <select @change="changeClass()" v-model="grade" name="" id="" class="form-control">
                      <option value="">Semua Kelas</option>
                      <option value="4">Kelas 4</option>
                      <option value="5">Kelas 5</option>
                      <option value="6">Kelas 6</option>
                      <option value="7">Kelas 7</option>
                      <option value="8">Kelas 8</option>
                      <option value="9">Kelas 9</option>
                      <option value="10">Kelas 10</option>
                      <option value="11">Kelas 11</option>
                      <option value="12">Kelas 12</option>
                    </select>
                  </div>
                  <div class="col-md-2" style="padding-bottom: 15px; padding-left: 0px">
                    <select @change="changeState()" v-model="state" name="" id="" class="form-control">
                      <option value="">Semua Status</option>
                      <option value="SUBSCRIPTION">SUBSCRIPTION</option>
                      <option value="TICKET">TICKET</option>
                      <option value="PUBLISHED">PUBLISHED</option>
                      <option value="UNPUBLISHED">UNPUBLISHED</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <div class="input-group">
                      <input type="text" class="form-control" @keyup.enter="searchfunction()" v-model="searchText"
                        placeholder="cari nama produk" />
                      <span class="input-group-addon" @click="searchfunction()" id="basic-addon2">Search</span>
                    </div>
                  </div>
                </div>

                <div class="" style="padding: 0px 0px 15px 0px;">
                  <div class="btn-group" role="group" aria-label="...">
                    <button type="button" class="btn btn-info" v-if="pagination.currentPage !== 1"
                      @click="previous()">Previous</button>
                    <button type="button" class="btn btn-default">{{ pagination.currentPage + ' / ' +
                      listProduk[0].page }}</button>
                    <button type="button" class="btn btn-info" v-if="pagination.currentPage < listProduk[0].page"
                      @click="next()">Next</button>
                  </div>
                </div>

                <ul class="list-group">
                  <li class="list-group-item" style="display: flex; flex-flow: row" v-for="item in listProduk"
                    :key="item.id">
                    <div class="col-md-2 col-xs-6">
                      <img :src="item.picture" style="width: 120px" />
                    </div>

                    <div class="col-md-8 col-xs-4">
                      <h4>{{ item.title }}</h4>
                      <p style="font-size: 15px; color:green;">Rp {{ item.net_price | currency }}</p>
                      <div style="margin: 15px 15px 15px 0px;">
                        <textarea v-model="item.short_description" :disabled="item.edit === false" class="form-control"
                          placeholder="Meta Tag Sosmed"></textarea>
                      </div>
                      <div class="input-group" style="width: 100px;">
                        <input :disabled="item.edit === false" v-model="item.persentate_commission" type="number"
                          class="form-control" placeholder="Dalam persen" style="border: 2px solid green" />
                        <span class="input-group-addon" id="basic-addon2">%</span>
                      </div>


                    </div>
                    <div class="col-md-2 col-xs-2">
                      <button v-if="item.edit === false" @click="item.edit = true" class="btn btn-warning btn-large">
                        Edit
                      </button>
                      <button v-if="item.edit === true" :disabled="item.status === 'UNPUBLISHED'"
                        @click="updateProduct(item)" class="btn btn-success btn-large">
                        Simpan
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <p id="msg"></p>
  </div>
</template>
<style>
li.list-group-item:hover {
  cursor: pointer;
  background-color: #f7f7f7;
}
</style>
<script>
import Spinner from "@/components/plugins/Spinner";
import logo from "@/assets/img/launcher.png";
import AffService from "@/services/affiliate.js";
import SalesService from "@/services/sales.js";
export default {
  name: "form-config-affiliate",
  components: {
    "app-spinner": Spinner,
  },
  data: function () {
    return {
      logo: logo,
      grade: "",
      state: '',
      isLoading: false,
      formConfig: {
        "hide_product_for_android": false,
        "coin_to_rupiah": 0,
        "admin_coin_fee": 0,
        "minimum_coin_withdraw": 0,
        "multiple_coin_withdraw": 0,
        "affiliate_message": ""
      },
      searchText: '',
      listProduk: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'asc',
      },
      search: {
        query: "",
        by: ""
      }
    };
  },
  mounted() {
    this.getConfig()
    this.getProduct()
  },
  filters: {
    currency(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    getConfig() {
      let context = this
      context.isLoading = true
      AffService.getConfigAffiliate(function (result) {
        context.isLoading = false;
        // if (result.success) {
          result.data.minimum_coin_withdraw /= result.data.coin_to_rupiah
          result.data.admin_coin_fee /= result.data.coin_to_rupiah
          result.data.multiple_coin_withdraw /= result.data.coin_to_rupiah
        context.formConfig = result.data;
        console.log(context.formConfig)
        // }
      });
    },
    changeClass() {
      let context = this
      context.pagination.currentPage = 1
      if (context.grade != '') {
        context.search.query = context.grade
        context.search.by = 'grade'
      }
      context.searchText = ''
      context.state = ''
      context.getProduct()
    },
    changeState() {
      let context = this
      context.pagination.currentPage = 1
      context.searchText = ''
      context.grade = ''
      if (context.state === 'SUBSCRIPTION' || context.state === 'TICKET') {
        context.search.query = context.state
        context.search.by = 'type'
      } else if (context.state === 'PUBLISHED' || context.state === 'UNPUBLISHED') {
        context.search.query = context.state
        context.search.by = 'status'
      }
      context.getProduct()
    },
    previous() {
      this.pagination.currentPage -= 1
      this.getProduct()
    },
    next() {
      this.pagination.currentPage += 1
      this.getProduct()
    },
    searchfunction() {
      let context = this
      if (context.searchText !== '') {
        context.search.query = context.searchText
        context.search.by = 'title'
      }
      context.pagination.currentPage = 1
      context.grade = ''
      context.state = ''
      context.getProduct()
    },
    getProduct() {
      let context = this
      context.isLoading = true

      SalesService.getProdukList(context.pagination, context.search, function (result) {
        context.isLoading = false;
        if (result.data.length > 0) {

          for (let index = 0; index < result.data.length; index++) {
            result.data[index].edit = false
          }
          context.listProduk = result.data
          console.log(context.listProduk)
        } else {
          alert('data tidak ditemukan')
        }
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    saveData() {
      let context = this
      let bd = this.formConfig
      if (bd.coin_to_rupiah < 1 || bd.admin_coin_fee < 1 || bd.minimum_coin_withdraw < 1 || bd.multiple_coin_withdraw < 1 ||
        bd.coin_to_rupiah === '' || bd.admin_coin_fee === '' || bd.minimum_coin_withdraw === '' || bd.multiple_coin_withdraw === '' || bd.affiliate_message === '') {
        alert('input tidak valid')
        return false
      }
      let body = bd
      body.minimum_coin_withdraw = bd.minimum_coin_withdraw * bd.coin_to_rupiah
      body.multiple_coin_withdraw = bd.multiple_coin_withdraw * bd.coin_to_rupiah
      body.admin_coin_fee = bd.admin_coin_fee * bd.coin_to_rupiah
      
      AffService.saveConfig(body, function (result) {
        if (result.success) {
          alert("Data config affiliate berhasil di simpan");
          context.getConfig()
        }
      });
    },
    updateProduct(item) {
      let context = this
      // if(item.short_description === '') item.short_description = null
      AffService.updateProduct(item, function (result) {
        if (result.success) {
          alert("Data persentase komisi produk berhasil di perbaharui");
          context.getProduct()
        } else {
          alert("Data persentase komisi produk gagal di perbaharui");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// AffiliateSetting.vue?29cde154